import { ILocalStorageClient } from "@agp/shared.user-app/infrastructure/local-storage-client";

export const localStorageClient: ILocalStorageClient = {
  get: (key: string) => localStorage.getItem(key),
  set: (key: string, value: any) => localStorage.setItem(key, value),
};
